module.exports = __webpack_public_path__ + "9418f0456973f81194a0700e7f913784.png";